import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {useOptionalSession} from '@aboutyou/user';
import {useSelectedTargetGroup} from '../../shared-deprecated/useSelectedTargetGroup';

// The header mounts this request eagerly. Importing the generated lazy module
// would drag every other search method that lazy pages use into the eager
// bundle, because rollup assigns whole modules to chunks. This reference is
// what that module would export for this one method.
const SearchService_GetEmptySearchPageLazy = () =>
  import(
    '@aboutyou/grpc-clients/tadarida/aysa_api/services/search/v1/service.grpc'
  ).then(m => m.SearchService_GetEmptySearchPage);
SearchService_GetEmptySearchPageLazy.method =
  'aysa_api.services.search.v1.SearchService/GetEmptySearchPage' as const;

// `disabled` lets the search bar mount this request before the panel exists and
// hold it until the user aims at the bar. The cache key is built from the
// params alone, so the dormant instance and the panel's own share one entry:
// whichever runs first fills it for the other.
export const useGetSearchSuggestionsTrending = (config?: {
  disabled?: boolean;
}) => {
  const session = useOptionalSession();
  const {targetGroup} = useSelectedTargetGroup();

  return useGrpcRequest(
    SearchService_GetEmptySearchPageLazy,
    {
      session,
      targetGroup,
    },
    config,
  );
};
